import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { StoreButtons } from "./StoreButtons";

export function Footer() {
  const links = [
    { label: "About", route: "/about" },
    { label: "Privacy", route: "/privacy" },
    { label: "Terms", route: "/terms" },
    { label: "Contact", route: "/contact" },
  ];
  return (
    <footer data-testid="web-footer" className="border-t border-white/[0.08]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center gap-2.5">
            <Logo size={26} />
            <span className="font-display text-lg font-extrabold tracking-tight text-acid">DMWrapped</span>
          </div>

          <h3 className="mt-8 font-display text-2xl font-bold tracking-tight text-paper">Get the app</h3>
          <p className="mt-2 max-w-md text-sm text-dim">
            A Wrapped-style report for your Instagram DMs — deeper stats, story-ready share cards,
            and streaks. Free on iOS and Android.
          </p>
          <div className="mt-6">
            <StoreButtons idPrefix="footer" size="md" center />
          </div>

          <nav className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {links.map((l) => (
              <Link
                key={l.route}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                to={l.route}
                className="text-sm font-semibold text-[#E1E2E6] underline-offset-4 transition-colors hover:text-acid hover:underline"
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <p className="mt-6 text-xs text-dim">
            © 2026 DMWrapped · Made with 💚 · Not affiliated with Instagram or Meta
          </p>
        </div>
      </div>
    </footer>
  );
}
